import React from 'react';
import { connect } from 'react-redux';
import '../../styles/screens/nyumba.scss';
import { say, alert, preloaderShow, preloaderHide } from "../../actions";
import axios from "axios";
import { config } from "../../app/config";
import ScreenComponent from "./ScreenComponent";
import { AlarmButton } from "./nyumba/AlarmButton";
import TranslationService from "../../app/services/TranslationService";
import {DevicesList} from "./nyumba/DevicesList";
import {Button} from "../icymat-design/Button";
import {LabeledInput} from "../icymat-design/LabeledInput";

export class NyumbaScreen extends ScreenComponent {
    /**
     * @param props
     */
    constructor(props) {
        super(props);
        this.state = {
            master: {
                name: '...',
                work_mode: 'manual',
                alarm: null
            },
            tab: 'scenes',
            scenes: {},
            devices: {},
            console: ''
        }
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.view !== this.getScreenName() && this.props.view === this.getScreenName()) {
            this.loadMasters();
        }
    };

    getScreenName = () => {
        return 'nyumba';
    }

    loadMasters = () => {
        this.props.preloaderShow();

        let that = this;
        axios.get(config.apiAddress + '/app/nyumba/masters')
            .then(function (response) {
                let ids = Object.keys(response.data);
                that.setState({master: response.data[ids[0]]});

                that.loadScenes();
            }).catch(function(response) {
                that.props.preloaderHide();
                that.setState({master: {name: TranslationService.trans(that.props.language, 'nyumba.actions.data_failed')}});
            });
    }

    loadScenes = () => {
        this.props.preloaderShow();

        let that = this;
        axios.get(config.apiAddress + '/app/nyumba/master/' + this.state.master.id + '/scenes')
            .then(function (response) {
                that.setState({scenes: response.data});

                that.loadDevices()
            }).catch(function(response) {
                that.props.preloaderHide();
                that.setState({master: {name: TranslationService.trans(that.props.language, 'nyumba.actions.data_failed')}});
            });
    }

    loadDevices = () => {
        this.props.preloaderShow();

        let that = this;
        axios.get(config.apiAddress + '/app/nyumba/master/' + this.state.master.id + '/devices')
            .then(function (response) {
                that.setState({devices: response.data});
                that.props.preloaderHide();
            }).catch(function(response) {
                that.props.preloaderHide();
                that.setState({master: {name: TranslationService.trans(that.props.language, 'nyumba.actions.data_failed')}});
            });
    }

    sendAction = (command) => {
        let that = this;
        axios.post(config.apiAddress + '/app/nyumba/master/' + this.state.master.id + '/instructions', {instructions: [command]})
            .then(function (response) {
                that.props.preloaderHide();
                that.props.alert(TranslationService.trans(that.props.language, 'nyumba.actions.send_command'));
            }).catch(function(response) {
            that.props.preloaderHide();
            that.props.alert(TranslationService.trans(that.props.language, 'nyumba.actions.send_failed'));
        });
    }

    renderSummary = () => {
        let renderButton = function(that) {
            if (that.state.master.work_mode === 'home') {
                return (<Button
                    text={TranslationService.trans(that.props.language, 'nyumba.work_mode.home')}
                    color={'green'}
                    secondary={true}
                    size={'sm'}
                    onClick={() => that.sendAction('workmode away')}
                />);
            } else if (that.state.master.work_mode === 'away') {
                return (<Button
                    text={TranslationService.trans(that.props.language, 'nyumba.work_mode.away')}
                    color={'yellow'}
                    secondary={true}
                    size={'sm'}
                    onClick={() => that.sendAction('workmode home')}
                />);
            } else if (that.state.master.work_mode === 'manual') {
                return (<Button
                    text={TranslationService.trans(that.props.language, 'nyumba.work_mode.manual')}
                    color={'blue'}
                    secondary={true}
                    size={'sm'}
                    onClick={() => that.sendAction('workmode home')}
                />);
            } else if (that.state.master.work_mode === 'silence') {
                return (<Button
                    text={TranslationService.trans(that.props.language, 'nyumba.work_mode.silence')}
                    color={'cyan'}
                    secondary={true}
                    size={'sm'}
                    onClick={() => that.sendAction('workmode home')}
                />);
            } else {
                return (<Button
                    text={TranslationService.trans(that.props.language, 'nyumba.work_mode.unknown')}
                    color={'gray'}
                    secondary={true}
                    size={'sm'}
                />);
            }
        };

        return (
            <div>
                {renderButton(this)}
                {
                    this.state.master.alarm && this.state.master.alarm !== null ?
                        <AlarmButton
                            status={this.state.master.alarm.status}
                            mode={this.state.master.alarm.mode}
                            masterId={this.state.master.id}
                            callback={this.loadMasters}
                        /> :
                        null
                }
            </div>
        );
    }

    renderScenes = () => {
        return (
            <div style={{maxHeight: '40vh', overflowY: 'auto'}} className={'imd-row'}>
                {
                    Object.keys(this.state.scenes).map(id => {
                        let scene = this.state.scenes[id];

                        return (<div key={id} className={'imd-col-xs-12 imd-col-md-6 imd-col-lg-3'}>
                            <div className={'imd-shadow-dark imd-text-white'} style={{margin: '7px', padding: '13px'}}>
                                {scene.name}
                                <button
                                    style={{fontSize: '2rem', border: 'none', background: 'none', float: 'right', padding: 0, marginTop: '-9px', cursor: 'pointer'}}
                                    onClick={() => this.sendAction('SCENE: ' + scene.id)}
                                >
                                    <span className="imd-icon imd-icon-play imd-text-teal"></span>
                                </button>
                            </div>
                        </div>)
                    })
                }
            </div>
        );
    }

    render() {
        /* eslint-disable */
        return (
            <div className="screen" style={this.getStyle()} id="screen-nyumba">
                <h1 className={"device-name"}>Nyumba: {this.state.master.name}</h1>

                <div style={{padding: '26px 0'}}>
                    {this.renderSummary()}
                </div>

                <div className="imd-tabs imd-tabs-top">
                    <ul className="imd-tabs-navigation">
                        <li className={(this.state.tab === 'scenes' ? 'imd-active' : null)}>
                            <a href="#" className="imd-border-color-main imd-text-main" onClick={() => this.setState({tab: 'scenes'})}>
                                {TranslationService.trans(this.props.language, 'nyumba.headers.scenes')}
                            </a>
                        </li>
                        <li className={(this.state.tab === 'devices' ? 'imd-active' : null)}>
                            <a href="#" className="imd-border-color-main imd-text-main" onClick={() => this.setState({tab: 'devices'})}>
                                {TranslationService.trans(this.props.language, 'nyumba.headers.devices')}
                            </a>
                        </li>
                        <li className={(this.state.tab === 'console' ? 'imd-active' : null)}>
                            <a href="#" className="imd-border-color-main imd-text-main" onClick={() => this.setState({tab: 'console'})}>
                                {TranslationService.trans(this.props.language, 'nyumba.headers.console')}
                            </a>
                        </li>
                    </ul>

                    <div className={'imd-tab imd-border-top-color-20-silver imd-border-bottom-color-20-silver imd-text-gray' + (this.state.tab === 'scenes' ? ' imd-active' : '')}>
                        <div className={"container"} style={{height: 'calc(100vh - 270px)'}}>
                            {this.renderScenes()}
                        </div>
                    </div>

                    <div className={'imd-tab imd-border-top-color-20-silver imd-border-bottom-color-20-silver imd-text-gray' + (this.state.tab === 'devices' ? ' imd-active' : '')}>
                        <div className={"container"} style={{height: 'calc(100vh - 270px)'}}>
                            <DevicesList devices={this.state.devices} sendAction={this.sendAction} />
                        </div>
                    </div>

                    <div className={'imd-tab imd-border-top-color-20-silver imd-border-bottom-color-20-silver imd-text-gray' + (this.state.tab === 'console' ? ' imd-active' : '')}>
                        <div className={"container"} style={{height: 'calc(100vh - 270px)'}}>
                            <LabeledInput
                                label={TranslationService.trans(this.props.language, 'nyumba.console.command')}
                                value={this.state.console}
                                onChange={e => {this.setState({console: e.target.value});}}
                            />

                            <Button
                                color={'main'}
                                text={TranslationService.trans(this.props.language, 'common.send')}
                                onClick={() => {this.sendAction(this.state.console); this.setState({console: ''});}}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
        /* eslint-enable */
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        language: TranslationService.getLanguage(state.user),
        view: state.view
    }
};
const mapDispatchToProps = {
    say,
    alert,
    preloaderShow,
    preloaderHide
};

export const NyumbaScreenContainer = connect(mapStateToProps, mapDispatchToProps)(NyumbaScreen);
